module.exports = __webpack_public_path__ + "static/media/logo.337cae2e.png";